<template>
  <b-container fluid v-if="!loading">
    <b-row align-h="end" v-if="searchEnabled">
      <b-col cols="4">
        <b-form-group class="mb-0">
          <b-input-group size="sm">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="text"
              placeholder="Search..."
            ></b-form-input>

            <b-input-group-append>
              <b-btn size="sm" variant="primary" @click="filter = ''">
                <i class="far fa-times-circle fa-lg"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Main table element -->
    <b-table
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="rowsPerPage"
      :filter="filter"
      :sort-by.sync="sortBy ? sortBy : defaultSortBy"
      :sort-desc.sync="computeSortDirection"
      :filter-included-fields="searchable_fields"
      sort-icon-left
      stacked="md"
      show-empty
      small
      @filtered="onFiltered"
    >
      <template #empty>
        <div class="text-center text-muted p-4">
          No data available
        </div>
      </template>

      <template
        v-for="(x, slotName) in $scopedSlots"
        v-slot:[slotName]="context"
      >
        <slot :name="slotName" v-bind="context" />
      </template>
    </b-table>

    <!-- PAGINATION -->
    <b-row>
      <b-col cols="auto" class="mr-auto p-3">
        <b-pagination
          v-model="currentPage"
          v-if="rowsPerPage !== Infinity"
          :total-rows="totalRows"
          :per-page="rowsPerPage"
          class="my-0"
        ></b-pagination>
      </b-col>
      <b-col cols="auto" class="p-3">
        <ul role="menubar" class="pagination my-0 b-pagination">
          <li
            v-for="items_per_page in pageOptions"
            :key="items_per_page"
            :class="
              items_per_page === rowsPerPage
                ? 'page-item active'
                : 'page-item'
            "
          >
            <button
              type="button"
              class="page-link"
              @click="rowsPerPage = items_per_page"
            >
              {{ items_per_page === Infinity ? "All" : items_per_page }}
            </button>
          </li>
        </ul>
      </b-col>
    </b-row>
  </b-container>

  <b-container v-else>
    <div class="d-flex justify-content-center mb-3">
      <b-spinner style="width: 6rem; height: 6rem;"></b-spinner>
    </div>
  </b-container>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    searchable_fields: {
      type: Array,
      required: false
    },
    sortBy: {
      type: String,
      required: false
    },
    sortDirection: {
      type: String,
      required: false
    },
    rowsPerPage: {
      type: Number,
      required: false,
      default: 20
    },
    searchEnabled: {
      type: Boolean,
      required: false,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      totalRows: 0,
      currentPage: 1,
      pageOptions: [10, 20, 50, 100, Infinity],
      defaultSortBy: "product_serial_num",
      filter: null,
    };
  },

  watch: {
    items: {
      handler(newValue) {
        this.totalRows = newValue.length;
        this.currentPage = 1;
      },
      immediate: true,
    },
  },

  computed: {
    computeSortDirection() {
      return this.sortDirection === "desc";
    },
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>